// extracted by mini-css-extract-plugin
export default {"root":"newMark-module__root--PiG8s","grid":"newMark-module__grid--KcuEI","ua":"newMark-module__ua--vzipH"};